export default __webpack_public_path__ + "static/media/holiday-header-harbolnas.2aa0be95.png";